var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + container.escapeExpression((lookupProperty(helpers,"translate")||(depth0 && lookupProperty(depth0,"translate"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"myProjects","copyToCreateProject",{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":4,"column":54}}}))
    + "\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + container.escapeExpression((lookupProperty(helpers,"translate")||(depth0 && lookupProperty(depth0,"translate"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"myProjects","saveToCreateProject",{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":6,"column":6},"end":{"line":6,"column":54}}}))
    + "\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + container.escapeExpression((lookupProperty(helpers,"translate")||(depth0 && lookupProperty(depth0,"translate"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"myProjects","copyToCreate",{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":21,"column":8},"end":{"line":21,"column":49}}}))
    + "\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + container.escapeExpression((lookupProperty(helpers,"translate")||(depth0 && lookupProperty(depth0,"translate"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"myProjects","saveToCreate",{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":23,"column":8},"end":{"line":23,"column":49}}}))
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<form class=\"CreateProjectModal-createForm\">\r\n  <h2 class=\"u-header2Small\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"copyFromProject") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "  </h2>\r\n\r\n  <label for=\"CreateProjectModal-nameInput\" class=\"CreateProjectModal-errorMessage\"></label>\r\n\r\n  <div class=\"CreateProjectModal-nameInput-wrapper\">\r\n    <input id=\"CreateProjectModal-nameInput\" class=\"CreateProjectModal-nameInput\" type=\"text\" placeholder=\""
    + alias3((lookupProperty(helpers,"translate")||(depth0 && lookupProperty(depth0,"translate"))||alias2).call(alias1,"myProjects","enterProjectName",{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":13,"column":107},"end":{"line":13,"column":152}}}))
    + "\" autocomplete=\"off\" maxlength=\"50\">\r\n    <i class=\"Icon Icon--cross\"></i>\r\n  </div>\r\n\r\n  <div class=\"CreateProjectModal-button-wrapper\">\r\n    <button class=\"CreateProjectModal-cancelButton Button Button--bordered\" type=\"button\">"
    + alias3((lookupProperty(helpers,"translate")||(depth0 && lookupProperty(depth0,"translate"))||alias2).call(alias1,"common","cancel",{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":18,"column":90},"end":{"line":18,"column":121}}}))
    + "</button>\r\n    <button class=\"CreateProjectModal-createButton Button Button--green\" type=\"submit\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"copyFromProject") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":20,"column":6},"end":{"line":24,"column":13}}})) != null ? stack1 : "")
    + "    </button>\r\n  </div>\r\n\r\n</form>\r\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./assets/components/DesignCenter/templates/create-project-modal.hbs
// module id = 1276
// module chunks = 1